import styled from 'styled-components';

const base = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  max-height: auto;
  padding: 1rem;
`;

const FrameFlex = {
  Base: base,
};

export default FrameFlex;
